export interface ILicenseUpgradeLogItem {
    ID: number;
    OldProductID: number;
    OrderID: number;
    InvoiceID: number;
    DateTimeCreated: Date;
    IP: string;

}

export class LicenseUpgradeLogArray extends Array<LicenseUpgradeLogItem> {

    constructor(...items: LicenseUpgradeLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, LicenseUpgradeLogArray.prototype);
    }

}

export class LicenseUpgradeLogItem implements ILicenseUpgradeLogItem {
        ID: number;
        OldProductID: number;
        OrderID: number;
        InvoiceID: number;
        DateTimeCreated: Date;
        IP: string;

}
